<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        コンテンツマスター取り込み
      </template>

      <template v-slot:content>
        <v-alert class="mt-5 ml-auto" v-if="vdropzoneMessages.length" type="info">
          <div v-for="(msg, index) in vdropzoneMessages" :key="index">
            {{ msg }}
          </div>
        </v-alert>
        <vue-dropzone
          ref="myVueDropzone2"
          id="dropzone2"
          :options="dropzoneOptions"
          @vdropzone-success="vdropzoneSuccess"
        />
      </template>
    </v-base-card>
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VBaseCard from '@/components/molecules/BaseCard'

export default {
  components: {
    VBaseCard,
    vueDropzone,
  },
  data () {
    return {
      dropzoneOptions: {
          url: `${this.$axios.defaults.baseURL}/api/v1/admin/contents/import`,
          method: 'post',
          headers: {
            'My-Awesome-Header': 'header value',
            'access-token': this.$axios.defaults.headers.common['access-token'],
            'client': this.$axios.defaults.headers.common['client'],
            'uid': this.$axios.defaults.headers.common['uid'],
          },
          thumbnailWidth: 150,
          maxFilesize: 0.5,
          dictDefaultMessage:"<i class='mdi mdi-cloud-upload'></i>ファイルをアップする",
          timeout: 600000
      },
      vdropzoneMessages: [],
      alert_type: null
    }
  },

  methods: {
    async vdropzoneSuccess (file, response) {
      const messages = response.messages
      this.vdropzoneMessages.push(`[${messages}]${file.name}`)
    },
  }
}
</script>

<style lang="stylus" scoped>
</style>
